import React from "react";
import {
  PAGE_STATE,
  useGetDigitalModuleContext,
} from "../../contextApi/digitalContext";
import { downloadTemplateForBulkDispatch } from "../../service";
import { getDownloadFileUrl } from "../../stockConsumption/form/helper";
import ScreenTopHeader from "../../dlpStockIssuance/ScreenTopHeader";
import { Card, CardBody } from "reactstrap";
import MarkEligibleTable from "./MarkEligibleTable";
import SuccessDialog from "../markEligible/SuccessDialog";

const MarkEligibleScreen = () => {
  const {
    setCurrentPageState,
    openSuccessPopup,
    setSuccessPopup,
    filterForm,
    markedEligibleRequest,
    setLoading,
    loading,
  } = useGetDigitalModuleContext();

  const downloadHandler = async () => {
    try {
      setLoading(true);
      const response = await downloadTemplateForBulkDispatch(
        markedEligibleRequest?.map((item) => ({
          ...item,
          status: [item?.status],
        }))
      );
      if (response?.code === 200) {
        getDownloadFileUrl(response?.data.key);
      }
      setLoading(false);
    } catch (error) {}
  };

  return (
    <div>
      <ScreenTopHeader
        goBackHandler={() => setCurrentPageState(PAGE_STATE.SEARCH_STUDENT)}
        labelText="Mark eligible to issue stocks"
      />
      <Card className="mx-3 my-4">
        <CardBody>
          <MarkEligibleTable />
        </CardBody>
        <SuccessDialog
          open={openSuccessPopup}
          handleClose={() => setSuccessPopup(false)}
          downloadHandler={downloadHandler}
          isLoading={loading}
        />
      </Card>
    </div>
  );
};

export default MarkEligibleScreen;
